import { Injectable } from '@angular/core';
import { CasesFilterParameters } from 'src/app/abstraction/cases.facade';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class ProvisionalControlFiltersService {

    private readonly STORAGE_KEY = 'filterListProvisionalControl';

    constructor(private storageService: StorageService) { }

    read(): CasesFilterParameters | null {
        return this.storageService.getObjectfromSessionStorage(this.STORAGE_KEY) ?? null;
    }

    write(filters: CasesFilterParameters): void {
        this.storageService.setObjectToSessionStorage(this.STORAGE_KEY, filters);
    }

    clear(): void {
        this.storageService.removeValuesByKeyOnSessionStorage(this.STORAGE_KEY);
    }
}
